module.exports = __webpack_public_path__ + "static/media/eye_logo_off.02168663.svg";